// extracted by css-extract-rspack-plugin
export default {"form":"o6ZXZQDJpL4BOXK_","delete":"lVrp6ugFpyoJWN9j","date_picker_width":"hQCtDenuXAYhfsUJ","labelDiv":"bakam5CnwoUlE6_u","btn":"FA6GP_UxPGEmQZTv","btns":"HvwWKAYi4s5YX6eN"};